// extracted by mini-css-extract-plugin
export var activityContainer = "_ny-0";
export var typingIndicatorContainer = "_ny-1";
export var typingIndicatorDot = "_ny-2";
export var wave = "_ny-3";